export default "__VITE_ASSET__ZqD47Sdg__"